import { Texto } from '@gravitate-js/excalibrr'
import { Progress } from 'antd'
import React from 'react'

export const ScorecardMetricCR = ({ value }) => {
  const getStatus = () => {
    if (value < 0.6) {
      return 'error'
    }
    if (value < 0.85) {
      return 'normal'
    }
    return 'success'
  }
  const getAppearance = () => {
    if (value < 0.6) {
      return 'warning'
    }
    if (value < 0.85) {
      return 'secondary'
    }
    return 'success'
  }
  return (
    <div className='flex items-center'>
      <Progress
        size='small'
        showInfo={false}
        className='driver-scorecard'
        strokeWidth={10}
        strokeLinecap='square'
        percent={value * 100}
        status={getStatus()}
      />
      <Texto className='pl-3' appearance={getAppearance()} category='h6' weight='bold'>
        {(value * 100).toLocaleString('en')}%
      </Texto>
    </div>
  )
}
